// src/pages/AboutPage.js

import React from 'react';
import PublicNavbar from '../components/PublicNavbar';
import Footer from '../components/Footer'; // Import the new Footer component
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <PublicNavbar />
      
      {/* New Hero Section */}
      <header className="about-hero">
        <div className="about-hero-content">
          <h1>About Us</h1>
          <p>Knowing that their community really cares</p> 
          <p>can make all the difference to someone in need.</p>
        </div>
      </header>

      {/* Main page content */}
      <div className="about-main-content">
        <main>
          <section className="about-section">
            <h2>From a Simple Idea to a Lifeline</h2>
            <p>
              Refuge AI was founded on a shared vision: We want everyone to have the opportunity to build a new great life for themselves, 
              regardless of their starting point. We see far too many, facing immense challenges and they are often finding solutions all on their own. 
              After a major setback, they are looking for a job, trying to find a place to live, or simply looking for their next meal. 
              Particularly the people who have just become homeless can find it difficult to identify what resources are available to them.
            </p>
            <p>
              That's where Refuge Ai hopes to help. We envisioned a single, intuitive app that would act as a trusted friend and guide, 
              putting essential resources directly into the hands of those who need them most. We wanted to do more than merely provide a 
              list of addresses; we offer a digital hub that empowers, encourages, and facilitates their first steps toward stability and success.  
            </p>
          </section>    
          <section className="about-section">
            <h2>Our Board of Directors</h2>
            
            <div className="team-container">
        
              <div className="team-member">
                  <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fboard_lb.png?alt=media&token=146ca0c7-815d-4b83-9cf2-d6439de2498d" alt="Lyle Black" className="member-photo" />
                  <div className="member-info">
                      <h2>Lyle Black</h2>
                      <p>Lyle W. Black is an entrepreneur, business leader, and advisor with a background in business development, 
                        organizational growth, and strategic partnerships. He has built and supported multiple organizations, including 
                        a national fundraising initiative that raised over $1 billion for youth athletic programs. He currently serves 
                        as President and CEO of NuWay Healthcare and has advised several companies and organizations. Mr. Black is 
                        passionate about helping individuals rebuild their lives and strengthen their communities.</p>
                  </div>
              </div>

              <div className="team-member">
                  <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fboard_ps.png?alt=media&token=c8777b57-59fe-4414-a902-7a41c7b25ec8" alt="Phillip Stoker" className="member-photo" />
                  <div className="member-info">
                      <h2>Philip Stoker</h2>
                      <p>Philip M. Stoker is a retired financial professional who enjoys time with family and serving in the community. 
                        He is the co-founder of Stoker Ostler Wealth Advisors, becoming the largest privately held investment advisory 
                        firm in Arizona.  Phil was an executive with BMO Harris Bank, Spectrum Financial Group and other financial 
                        institutions.  He serves on the board of Affinity Group and has served on the boards of Delta Dental, 
                        Illinois and Arizona BYU Management Society, International Association for Financial Planning and Inner-City 
                        Youth Charitable Trust.  Phil has also served in many local leadership positions in his church, plus 
                        assignments in New England, Africa and Europe.  He believes it is important to give back, following the 
                        teaching of Jesus “to whom much is given, much is expected”.</p>
                  </div>
              </div>

              <div className="team-member">
                  <img src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Fboard_lt.png?alt=media&token=abe781f4-f033-41a3-97ee-10644949f82a" alt="Linda Tanner" className="member-photo" />
                  <div className="member-info">
                      <h2>Linda Tanner</h2>
                      <p>Linda is a seasoned executive and strategic visionary bringing over two decades of leadership in operational 
                        logistics, marketing, and community advocacy to the Board.Her career is defined by navigating complex domestic 
                        and international supply chains and building brand identities from the ground up. Beyond her corporate background, 
                        Linda is deeply committed to the non-profit sector as both a founder and active leader in mission-driven operations.
                        She considers working in the non-profit field the most rewarding of pursuits among all possible options. Her joy is 
                        in building genuine human connections which bring dignity to individuals and create stronger more vibrant communities.
                        </p>
                  </div>
              </div>

            </div>

          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;